import { render, staticRenderFns } from "./ChatReviewsDetails.vue?vue&type=template&id=f5957520&"
import script from "./ChatReviewsDetails.vue?vue&type=script&lang=ts&"
export * from "./ChatReviewsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ChatReviewsDetails.vue?vue&type=style&index=0&id=f5957520&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports